import React, { useContext, useEffect } from 'react'
import { useLazyQuery, NetworkStatus, gql } from '@apollo/client'
import { omit } from 'lodash'
import CardWidget, { Colors } from '../../../../../components/CardWidget'
import CardWidgetSkeleton from '../../../../../components/skeletons/CardWidgetSkeleton'
import { PharmaciesDetailsFiltersContext } from '../../../../../context/PharmaciesDetailsFiltersContext'

const GET_QUANTITY_ORDERS = gql`
  query TotalOffer($filters: NewOrderFilter) {
    pharmaciesAggs(
      size: 0
      filters: $filters
      aggs: { pharmacyTotalOffers: { terms: { field: "pharmacyTotalOffer" } } }
    ) {
      aggregations
    }
  }
`

const QuantityOffers = (): JSX.Element => {
  const { filters } = useContext(PharmaciesDetailsFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_QUANTITY_ORDERS,
    {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData({
      variables: { orderCreatedAt: filters.createdAt, ...omit(filters, 'createdAt') }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <CardWidgetSkeleton />
  if (loading || !data) return <CardWidgetSkeleton />
  if (error) return <p>Error :(</p>

  const totalOffer = data.pharmaciesAggs.aggregations.pharmacyTotalOffers?.buckets[0]?.key

  return (
    <CardWidget
      title="Quantidade de ofertas"
      number={totalOffer}
      color={Colors.green}
    />
  )
}

export default QuantityOffers
